// ** Initial State
const initialState = {
  bids: [],
  all_bids: [],
  total_bids: 0,
  selectedBid: {},
  selectedStatus: [
    "pending",
    "rejected",
    "not-accepted",
    "accepted",
    "validated",
    "cleared",
    "not-cleared",
  ],
};

const bid = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_BIDS":
      return { ...state, bids: action.bids, total_bids: action.total };
    case "FETCH_ALL_BIDS":
      return { ...state, all_bids: action.all_bids };
    case "ADD_BID":
      return { ...state };
    case "REMOVE_BID":
      return { ...state };
    case "UPDATE_BID":
      return { ...state };
    case "UPDATE_BID_FILTERS":
      // ** Updates Filters based on action filter
      const filterIndex = state.selectedStatus.findIndex(
        (i) => i === action.filter
      );
      if (state.selectedStatus.includes(action.filter)) {
        state.selectedStatus.splice(filterIndex, 1);
      } else {
        state.selectedStatus.push(action.filter);
      }
      return { ...state };
    case "UPDATE_BID_ALL_FILTERS":
      // ** Updates All Filters based on action value
      const value = action.value;
      let selected = [];
      if (value === true) {
        selected = [
          "pending",
          "rejected",
          "not-accepted",
          "accepted",
          "validated",
          "cleared",
          "not-cleared",
        ];
      } else {
        selected = [];
      }
      return { ...state, selectedStatus: selected };
    case "SELECT_BID":
      return { ...state, selectedBid: action.bid };
    case "SELECT_BID_BY_ID":
      let selectedBid = state.bids.filter(
        (bid) => bid.id === parseInt(action.id)
      )[0];
      return { ...state, selectedBid };
    default:
      return state;
  }
};

export default bid;
